<template>
  <div></div>
</template>
<script>
export default {
  name: 'DownLoadApp',
  data() {
    return {};
  },
  created() {
    this.$util.jumpAppStore();
  }
};
</script>
<style lang="scss" scoped></style>
